import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import StatusBar from '../common/StatusBar';

import { getCurrencySymbol } from '../../helpers';
import moment from 'moment';
import { useAutoTranslation } from '../../helpers/useAutoTranslation';

const Table = (props) => {
  const { title, headers, items, link } = props;

  const { checkoutSettings } = useSelector((state) => state.settings);
  const currencySymbol = getCurrencySymbol(checkoutSettings.currency);

  const { t } = useAutoTranslation();

  return (
    <div className="col-xl-6" style={{ display: `flex` }}>
      <div className="card-box" style={{ flexGrow: 1 }}>
        <h4 className="header-title mb-3">{title}</h4>
        {items[0] && items[0].avgItemSum && (
          <div className="alert alert-warning warning">
            <i className="mdi mdi-alert-outline mr-2" />
            {t('Стоимость выводится с учётом скидок и изменения цен')}
          </div>
        )}
        <div className="table-responsive">
          <table className="table table-borderless table-nowrap table-hover table-centered m-0">
            <thead className="thead-light">
              <tr>
                {headers.map((header) => (
                  <th key={header}>{header}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {items &&
                items.map((item, index) => (
                  <tr key={index.toString()}>
                    <td>
                      {link ? (
                        <Link to={`${link}${item.id}`}>
                          <h5 className="m-0 font-weight font-13">{item.name || item.id}</h5>
                        </Link>
                      ) : (
                        <h5 className="m-0 font-weight-normal font-13">{item.name || item.id}</h5>
                      )}
                    </td>
                    <td style={{ whiteSpace: `nowrap` }}>
                      {item.updateTs ? (
                        <>
                          <p
                            style={{
                              margin: 0,
                              fontWeight: `bold`,
                            }}
                          >
                            {moment(item.updateTs).format(`DD.MM.YYYY`)}
                          </p>
                          <p style={{ margin: 0 }}>{moment(item.updateTs).format(`HH:mm:SS`)}</p>
                        </>
                      ) : (
                        item.avgItemSum && `${item.avgItemSum} ₽`
                      )}
                    </td>
                    <td>{item.amount || <StatusBar status={item.status} />}</td>
                    <td style={{ whiteSpace: `nowrap` }}>
                      {`${(
                        item.totalSum ||
                        item.totalOrderSum ||
                        0
                      ).toLocaleString()} ${currencySymbol}`}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Table;
